import { DataSourceService } from './'
import { NestAPI } from '../../nestapi'
import { DataSource } from '@marketing-milk/interfaces'

export class DataSourceImplementation implements DataSourceService {
  getAll(): Promise<DataSource[]> {
    return NestAPI.get('/data_sources') as any
  }
}
